/* @flow */
import enumerate from 'lib/enumerate';

export const ActionTypes = enumerate([
  'LOAD_CLASS_MEMBERS',
  'PROMOTED_CLASS_MEMBERS',
  'REMOVE_SUBSCRIBER',
]);



// WEBPACK FOOTER //
// ./src/constants/GroupMembershipConstants.js